import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EnvironmentInjector, Inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ModalService } from '@indice/ng-components';
import { TranslocoDirective } from '@jsverse/transloco';
import { BehaviorSubject, catchError, finalize, of, switchMap } from 'rxjs';
import {
  InsertOrderItemRequest,
  InsertOrderRequest,
  ProductResponse,
  ServicesPaymentsApiService
} from 'src/app/core/services/payments-api-service';
import { CmsApiService } from 'src/app/services/cms-api.service';
import {
  FloorType,
  LookingForPropertyOfType,
  PropertySummary
} from 'src/app/services/portal-api.service';
import {
  propertyData,
  PropertyListingService,
} from 'src/app/services/property.service';
import { ToasterService, ToastType } from 'src/app/services/toaster.service';
import { WorkflowApiService } from 'src/app/services/workflow.service';
import { checkoutDefaultSteps, createStepMapFromStringArray, navigateToCheckout } from 'src/app/shared/components/checkout/utils';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';
import { OnboardingExitModalComponent } from '../onboarding/onboarding-exit-modal/onboarding-exit-modal.component';
import {
  FloorTypeOptions,
} from './appartment-options/apartment-options.component';
import { mapProductsToCheckoutProducts } from './ProductUtils/products';
import { StepFiveComponent } from './step-five/step-five.component';
import { CheckoutProduct } from './step-four/product-card/product-card.component';
import { StepFourComponents } from './step-four/step-four.component';
import { StepOneComponent, StepOneData } from './step-one/step-one.component';
import {
  StepThreeComponent,
  StepThreeData,
} from './step-three/step-three.component';
import { StepTwoComponent, StepTwoData } from './step-two/step-two.component';

export interface PropertyUpload extends propertyData {
  //apartmentFloorType?: ApartmentOptions;
  constructionYear?: string;
  choosenPackage?: CheckoutProduct
  floor?: number,
  floorType?: FloorType | undefined,
  numberOfFloors?: number
  numberOfFloorsFloorType?: FloorType | undefined
}

@Component({
  selector: 'app-property-upload-wizard',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    NgxSliderModule,
    RouterModule,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponents,
    StepFiveComponent,
  ],
  templateUrl: './property-upload-wizard.component.html',
  styleUrl: './property-upload-wizard.component.css',
})
export class PropertyUploadWizardComponent implements AfterViewInit {
  SelectedPropertyType: LookingForPropertyOfType | undefined;
  SelectedFloor: FloorTypeOptions | undefined;
  propertyTypes = LookingForPropertyOfType;
  apartmentTypes = FloorTypeOptions;
  Step: string = 'Step1';
  Steps: string[] = [
    'asset-onboarding-step-1',
    'asset-onboarding-step-2',
    'asset-onboarding-step-3',
    'asset-onboarding-step-4',
    'asset-onboarding-step-5'
  ].concat([checkoutDefaultSteps.first, checkoutDefaultSteps.second, 'shared.checkout.my-profile.selling.selling-details.navlinks.overview']);


  propertyUploadData: PropertyUpload = {};
  propertyArea: string | null = null;
  constructionYear: string | undefined = undefined;
  placeMarker: BehaviorSubject<PropertySummary[]> = new BehaviorSubject<PropertySummary[]>([]);
  encodedLocationBounds: string | undefined;
  unicoProducts?: ProductResponse[]
  productListSelection: CheckoutProduct[] = []
  loading = false;
  termsAreAccepted = false;
  constructor(
    private modalService: ModalService,
    private router: Router,
    private propertyService: PropertyListingService,
    private cmsService: CmsApiService,
    private paymentsApiService: ServicesPaymentsApiService,
    private workflowApiService: WorkflowApiService,
    private toaster: ToasterService,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector,
  ) {
   }

  ngAfterViewInit() {
    this.scrollToTop();
  }

  OpenModalComponent() {
    const exitModal = this.modalService.show(OnboardingExitModalComponent, {
      animated: true,
      keyboard: true,
      class: 'h-dvh md:h-auto',
    });
    exitModal.onHidden?.subscribe((response: any) => { });
  }

  scrollToTop() {
    // this.scrollableDiv.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  SaveStep1(data: StepOneData) {
    this.propertyUploadData =
    {
      ...this.propertyUploadData,
      PropertyType: data.data.propertyType,
      PropertyArea: Number.parseInt(data.data.squaredMeters),
      constructionYear: data.data.constructionYear,
      floor: data.data.floor,
      floorType: data.data.floorType,
      numberOfFloors: data.data.numberOfFloors,
      numberOfFloorsFloorType: data.data.numberOfFloorsFloorType
    };

    console.log(`floor: ${this.propertyUploadData.floor}, floorType: ${this.propertyUploadData.floorType}, numberOfFloors: ${this.propertyUploadData.numberOfFloors}, numberOfFloorsFloortype: ${this.propertyUploadData.numberOfFloorsFloorType}`);
    this.scrollToTop()
    this.Step = 'Step2';
  }

  GoTo(step: string) {
    if (
      step === 'Step1' ||
      step === 'Step2' ||
      step === 'Step3' ||
      step === 'Step4' ||
      step === 'Step5' ||
      step === 'Step6' ||
      step === 'Step7'
    ) {
      this.Step = step;
    }
  }
  SaveStep2(data: StepTwoData) {
    if (!data.valid) return;
    this.encodedLocationBounds = data.data.encodedLocationBounds;
    this.placeMarker.next(data.data.placeMarker);
    const address = this.placeMarker.value[0].address?.geoPoint?.split(',')
    this.propertyUploadData.PropertyAddress = {
      ...this.propertyUploadData.PropertyAddress,
      Lat: address?.[0],
      Lon: address?.[1],
      ...data.data.place
    };
    this.Step = 'Step3';
    this.scrollToTop()
  }

  SaveStep3(data: StepThreeData) {
    if (data.data.maxPriceValue && data.data.minPriceValue) {
      this.propertyUploadData.MinPrice = data.data.minPriceValue;
      this.propertyUploadData.MaxPrice = data.data.maxPriceValue;
    }
    if (this.productListSelection.length > 0) {
      this.Step = data.nextStep;
      return;

    }
    this.paymentsApiService.getUnicoProducts().pipe().subscribe((products) => {
      this.unicoProducts = products;
      this.cmsService.unicoProducts().pipe().subscribe(resp2 => {
        this.productListSelection = mapProductsToCheckoutProducts(products ?? [], resp2, this.envInjector)
      })
    })
    this.Step = data.nextStep;
    this.scrollToTop()
  }

  SaveStep4(data: CheckoutProduct) {
    this.propertyUploadData.choosenPackage = data;
    this.Step = 'Step5';
    this.scrollToTop()
  }

  onChangeConsent(data:boolean){
    this.termsAreAccepted = data
  }

  SaveStep5() {
    this.loading = true;
    this.propertyService.createPropertyBasicInfo(this.propertyUploadData)
      .pipe(
        switchMap(resp => {
          const orderItems: InsertOrderItemRequest[] =
            [
              new InsertOrderItemRequest({
                propertyId: resp.propertyId,
                quantity: 1,
                sku: this.propertyUploadData.choosenPackage?.sku ?? ''
              })
            ]

          const body = new InsertOrderRequest({
            currency: 'EUR',
            orderItems: orderItems
          });

          return this.paymentsApiService.createMyOrder(body);
        }),
        switchMap((orderResp) => {
          const orderId = orderResp.number;
          if (orderResp?.id) {
            const steps = createStepMapFromStringArray(this.Steps, -5)
            // console.log({steps:steps})
            return navigateToCheckout(this.router,`/checkout/${orderResp.number}`, steps);
          }
          return this.router.navigate([localizeRoute('/home', this.envInjector)]);
        }),
        catchError((e) => {
          this.toaster.showBanner(ToastType.Error, "There was an error proceeding with your request.", e.detail, 3000);
          return of(null);
        }),
        finalize(() => this.loading = false)
      )
      .subscribe();
  }
}
